import { subHours } from "date-fns";

export const getEndOfValidDate = () => {
  const today = new Date();
  return subHours(today, 1); // the script of backend will be done 01:00
};
